
export default {
  data () {
    return {
      // 分页相关
      pageNo: 1,
      pageSize: 10,
      pageSizeArr: [10, 20, 30, 40, 50, 100],
      paginationLayout: 'total, sizes, prev, pager, next, jumper',
      totalEl: 0, // 总计
      listLoading: false, // 列表加载动画
      tableData: [], // 展示数据
      tableHeight: window.innerHeight - 350 // 表格最大高度
    }
  },
  methods: {
    // 查询
    searchAct () {
      this.pageNo = 1
      this.getList()
    },
    // 分页size改变
    handleSizeChange (val) {
      this.pageNo = 1
      this.pageSize = val
      this.getList()
    },
    // 分页-换页
    handleCurrentChange (val) {
      this.pageNo = val
      this.getList()
    }
  }
}
